import { BackendResponse } from "../BackendResponse";
import { FormDataWithKeyCheck } from "../FormDataFactory";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface QuickApplyResponse extends BackendResponse {
  item: string;
}

export interface _QuickApplyParameters extends NextApiParams {
  formData: FormDataWithKeyCheck<QuickApplyParameters>;
}

export const quickApply = withNextApi<
  QuickApplyResponse,
  _QuickApplyParameters
>("Auth/QuickApply");

export interface QuickApplyParameters {
  concernId: number;
  relatedId: number;
  relatedType: number;
  consent: boolean;
  enableParameterOverride: boolean;
}
